define('addMindkeyRequired',['jquery'],
function ($) {
    var $checkboxes = $('.mindkeyCheckBox input[type="checkbox"]');

    console.log($checkboxes);
    

    if (!$checkboxes.length) {
        return;
    }

    //Change checkboxes prop
    $checkboxes.prop('required', true);

    var $allowSaveCheckbox1 = $('#content_1_ctl00_AllowSave');
    console.log("$allowSaveCheckbox", $allowSaveCheckbox1);
    if ($allowSaveCheckbox1) {
        $allowSaveCheckbox1.prop('checked', true);
    }

    var $allowSaveCheckbox0 = $('#content_0_ctl00_AllowSave');
    console.log("$allowSaveCheckbox", $allowSaveCheckbox0);
    if ($allowSaveCheckbox0) {
        $allowSaveCheckbox0.prop('checked', true);
    }
    

});

